import React from 'react';
import { useSearchParams } from 'react-router-dom';
import AvisosConsumidorView from './AvisosConsumidorView';
import AvisosSistemaView from './AvisosSistemaView';
import NovidadesTiView from './NovidadesTiView';

type Aba = 'consumidor' | 'sistema' | 'solicitacoes-ti';

/**
 * A aba mora na query string (?aba=sistema), não em useState local — mesmo padrão de
 * LembretesCobrancaView.tsx. Sem isso, um admin no meio de "Avisos do Sistema" que dá F5
 * (ou recebe um link direto pra essa aba) sempre cai de volta em "Avisos ao Consumidor".
 */
const AvisosView: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const abaParam = searchParams.get('aba');
    const aba: Aba = abaParam === 'sistema' || abaParam === 'solicitacoes-ti' ? abaParam : 'consumidor';

    const trocarAba = (nova: Aba) => {
        const proximos = new URLSearchParams(searchParams);
        proximos.set('aba', nova);
        setSearchParams(proximos, { replace: true });
    };

    return (
        <div className="space-y-6">
            <div className="flex bg-gray-100 dark:bg-gray-800 rounded-xl p-1 max-w-xl">
                {([['consumidor', 'Avisos ao Consumidor'], ['sistema', 'Avisos do Sistema'], ['solicitacoes-ti', 'Novidades TI']] as const).map(([valor, label]) => (
                    <button
                        key={valor}
                        onClick={() => trocarAba(valor)}
                        className={`flex-1 py-2.5 rounded-lg text-sm font-bold transition-all ${aba === valor
                            ? 'bg-white dark:bg-gray-700 text-primary shadow-sm'
                            : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200'
                            }`}
                    >
                        {label}
                    </button>
                ))}
            </div>
            {aba === 'consumidor' && <AvisosConsumidorView />}
            {aba === 'sistema' && <AvisosSistemaView />}
            {aba === 'solicitacoes-ti' && <NovidadesTiView />}
        </div>
    );
};

export default AvisosView;
